import React from 'react';
import { XAlert } from '../../x/alert/XAlert';
import { XText, XTextType } from '../../x/text/XText';
import { UiGrid, UiIconMaterial, UiFlex } from '@open-stack/ui';
import { useGeolocation } from '../../../hooks/geolocation';
import { XButton, XSection } from '@orderx/lab/ui';

export function BrowseGeolocation() {
    const { canRequest, requestLocation } = useGeolocation();

    if (canRequest) {
        return (
            <XSection>
                <XAlert>
                    <UiGrid fullWidth>
                        <UiFlex gap={2}>
                            <UiIconMaterial fontSize={6}>location_on</UiIconMaterial>

                            <UiGrid gap={0}>
                                <XText type={XTextType.TITLE}>We are not sure where you are...</XText>
                                <XText>Can we use your location to display nearest bars and restaurants?</XText>
                            </UiGrid>
                        </UiFlex>

                        <XButton onClick={requestLocation}>Okay!</XButton>
                    </UiGrid>
                </XAlert>
            </XSection>
        );
    }

    return null;
}
